// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true,
    filterTreeMobileStyle: 'style3',
	},
};

(function() {
	BoostPFS.inject(this);
	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		var itemVariantFirstId = firstVariant.id;
  		itemHtml = itemHtml.replace(/{{itemVariantId}}/g, itemVariantFirstId);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);
		var life_style = Utils.getProductMetafield(data, "accentuate", "life_style_product");
		var life_img_style = JSON.parse(life_style);
        //console.log(data);
		// Add Images
		var aspect_ratio = '';
        var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
        if(life_img_style != null ){
  			itemImagesHtml += '<span id="life_style_image">'+life_img_style+'</span>';
  			itemImagesHtml += '<script>var lfimg=document.querySelector(".boost-pfs-filter-products.bc-al-style4 .grid__item:nth-child(4)"),lfchnge=document.querySelector(".boost-pfs-filter-products.bc-al-style4 .grid__item:nth-child(4) .default_image_product");if (lfimg && lfimg.querySelector("#life_style_image")){var e=lfimg.querySelector("#life_style_image").innerText.trim();lfchnge.src=e}</script>';
  		}


        itemImagesHtml += '<a href="'+'/products/' + data.handle+'" class="featured_image"><img id="' + imgId + '" ' +
          'class="grid-view-item__image show_img_on_hover default_image_product lazyload" ' +
          'src="' + Utils.getFeaturedImage(images, '600x600') + '" ' +
          'alt="{{itemTitle}}"></a>';

        itemImagesHtml += '<div class="p_img_slider">';
        var video_first = false;
		if(
			data &&
			data.media &&
			data.media[0] &&
			data.media[0].mediaContentType == 'VIDEO'
		){
			video_first = true;
		}
        //console.log(data.media[0]);
        if(video_first){
            itemImagesHtml += '<video autoplay="autoplay" loop="loop" class="grid-view-item__image feature_image" playsinline="playsinline" preload="metadata" aria-label="' + data.title + '" muted><source src="' + data.media[0].sources[0].url + '" type="application/x-mpegURL"><source src="' + data.media[0].sources[1].url + '" type="video/mp4"></video>';
        }else{
             const startingIndex = 1; // The index of 'image2.jpg'
              for (let i = startingIndex; i < images.length; i++) {
              const image = new Image();
              let tmpImage = Array();
              tmpImage.push(images[i]);
              itemImagesHtml += '<a href="'+'/products/' + data.handle+'" class="featured_image"><img id="' + imgId + '" ' +
              'class="grid-view-item__image lazyload" ' +
              'src="' + Utils.getFeaturedImage(tmpImage, '600x600') + '" ' +
              'alt="{{itemTitle}}"></a>';
              }
        }

		itemImagesHtml += '</div></div>';

		// Custom product Tag for Fella Theme
		let tags = data.tags;
		let isNewArrival = false;
		let isPreOrder = false;
		tags.forEach(function(tag) {
			if (tag === 'NEWARRIVAL' || tag === 'NEWARRIVALS'){
				isNewArrival = true;
			};
			if (tag === 'W-PREORDER'){
				isPreOrder = true;
			};
		});
		itemImagesHtml += '<div class="product-label">';

		// Other promotation label
		$.each(boostPFSConfig.product_promo_label_setting, function(index, promo) {
			if (promo.enable) {
				// check product include promo condition handle
				let promoCollectionHandleData = promo.collection_handle ? promo.collection_handle.split(',') : '';
				let promoProductHandleData = promo.product_handle ? promo.product_handle.split(',') : '';
				let isInclCollectionHandle = false;
				$.each(data.collections, function(i, collection) {
					if ($.inArray(collection.handle, promoCollectionHandleData) !== -1) isInclCollectionHandle = true;
				});

				if ($.inArray(boostPFSConfig.custom.handle, promoCollectionHandleData) !== -1
				|| $.inArray(data.handle, promoProductHandleData) !== -1
				|| isInclCollectionHandle
				) {
					// check expiry date is avaible
					if (promo.expiry_date == '') {
						itemImagesHtml += '<span style="color:'+promo.text_color+';background-color:'+promo.background_color+';" class="label-promo">'+promo.text+'</span>';
					} else {
						let expiryDate = Date.parse(promo.expiry_date);
						let now = Date.now();
						if (!isNaN(expiryDate) && expiryDate >= now) {
							itemImagesHtml += '<span style="color:'+promo.text_color+';background-color:'+promo.background_color+';" class="label-promo">'+promo.text+'</span>';
						}
					}
				}
			}
		});
		// End other promotation label

		// Main Label
		let limitArrivalEnDays = parseInt(boostPFSConfig.product_tag_setting.new_arrival_label);
		limitArrivalEnDays = Number.isInteger(limitArrivalEnDays) ? limitArrivalEnDays : 7;
		let productCreateDate = Date.parse(data.created_at);
		let timeSpanTmp = productCreateDate + limitArrivalEnDays * 86400000;
		let currentlyTime = Date.parse(new Date);
		let showNewArriva = true;
		let showPreorder = true;
		let sale_label_text = boostPFSConfig.product_tag_setting.sale_label;
		let sale_label_class = 'hide';
		if(onSale){
			showNewArriva = false;
			showPreorder = false;
			sale_label_class = 'show';
		}
		itemImagesHtml += '<span style="color:'+boostPFSConfig.product_tag_setting.sale_text_color+';background-color:'+boostPFSConfig.product_tag_setting.sale_bg_color+'" class="label-sale '+sale_label_class+'">'+sale_label_text+'</span>';

		let preorder_label_text = boostPFSConfig.product_tag_setting.pre_order_label;
		let label_preoder_class = 'hide';
		if(isPreOrder && showPreorder){
			label_preoder_class = ' show';
			showNewArriva = false;
		}

		let new_label_text = boostPFSConfig.product_tag_setting.new_arrival_label;
		let label_new_class = 'hide';
		if(isNewArrival && showNewArriva){
			label_new_class = ' show';
		}

		itemImagesHtml += '<span style="color:'+boostPFSConfig.product_tag_setting.pre_order_text_color+';background-color:'+boostPFSConfig.product_tag_setting.pre_order_bg_color+'" class="label-preorder '+label_preoder_class+'">'+preorder_label_text+'</span>';


		itemImagesHtml += '<span style="color:'+boostPFSConfig.product_tag_setting.new_arrival_text_color+';background-color:'+boostPFSConfig.product_tag_setting.new_arrival_bg_color+';" class="label-new '+label_new_class+'">'+new_label_text+'</span>';

		itemImagesHtml += ' </div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="grid-view-item__image" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';

		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = buildPriceNew(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add custom Variant for Fella Theme
		var itemVariantsHtml = buildVariants(data);
		itemHtml = itemHtml.replace(/{{itemVariants}}/g, itemVariantsHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, '/products/' + data.handle);

		if(typeof Utils.compileShopifyProductVariables == 'function'){
          itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }

        if(typeof Utils.compileShopifyProductMetafield == 'function'){
        	itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }
		itemHtml = itemHtml.replace(/{{itemMeta}}/g, '');
		/** Custom Layout For Fella Theme
		Type custom lyaout must include: layout1, layout2, layout3, layout4  */
		if (typeof boostPFSThemeConfig.custom_layout !== "undefined" && typeof boostPFSThemeConfig.custom_layout.layout_type !== "undefined") {
			itemHtml = _addExtralBanners(itemHtml, boostPFSThemeConfig.custom_layout, this);
		}

		/** Custom Layout For Fella Theme */

		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add Reviews
		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if(typeof Utils.compileShopifyProductVariables == 'function'){
          itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
        }

        if(typeof Utils.compileShopifyProductMetafield == 'function'){
        	itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
        }

		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPrice(data, onSale, priceVaries) {
		//console.log(data);
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
		var soldOutClass = data.available ? '' : ' price--sold-out';
		var comparePriceVaries = data.compare_at_price_min != data.compare_at_price_max;
		var priceVariesClass = !priceVaries && comparePriceVaries ? ' price--compare-price-hidden' : '',
			variant = data.variants[0],
			unitPriceMeasurementClass = '',
			unitPriceSeparatorHtml = '',
			unitPirceBaseUnitHtml = '';

		if (variant.hasOwnProperty('unit_price_measurement')) {
			unitPriceMeasurementClass = ' price--unit-available';
		}

		priceHtml += '<dl class="price price--listing' + onSaleClass + soldOutClass + priceVariesClass + unitPriceMeasurementClass + '" data-price>';
		if (boostPFSConfig.custom.hasOwnProperty('vendor_enable') && boostPFSConfig.custom.vendor_enable == true) {
			priceHtml += '<div class="price__vendor price__vendor--listing"><dt>';
			priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
			priceHtml += '</dt><dd>';
			priceHtml += data.vendor;
			priceHtml += '</dd></div>';
		}

		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt><span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		if(data.template_suffix == 'gift_cart' || data.template_suffix == 'phisycal_gift_card'){
			priceHtml += '<span class="price-label">From </span>';
		}
		priceHtml += '</dt><dd>';
		priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
		if (priceVaries) {
			priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
		} else {
			priceHtml += Utils.formatMoney(data.price_min);
		}
		priceHtml += '</span></dd></div>';

		priceHtml += '<div class="price__sale"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.sale_price +
			'</span></dt>';
		priceHtml += '<dd> <span class="price-item price-item--sale">';
		if (priceVaries) {
			priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
		} else {
			priceHtml += Utils.formatMoney(data.price_min);
		}
		priceHtml += '</span></dd>';
		priceHtml += '<div class="price__compare"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.regular_price;
		priceHtml += '</span></dt>';
		priceHtml += '<dd> <s class="price-item price-item--regular">';
		priceHtml += Utils.formatMoney(data.compare_at_price_min);
		priceHtml += '</s></dd></div>';
		priceHtml += '</div>';

		priceHtml += '<div class="price__unit"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.unit_price_label;
		priceHtml += '</span></dt>';
		priceHtml += '<dd class="price-unit-price">';

		unitPriceSeparatorHtml += '<span aria-hidden="true">/</span><span class="visually-hidden">';
		unitPriceSeparatorHtml += boostPFSConfig.label.unit_price_separator + '&nbsp;</span>';

		if (variant.hasOwnProperty('unit_price_measurement') && variant.unit_price_measurement) {
			unitPirceBaseUnitHtml += '<span>';
			if (variant.hasOwnProperty('reference_value') && variant.unit_price_measurement.reference_value != 1) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_value;
			}
			if (variant.hasOwnProperty('reference_unit')) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_unit;
			}
			unitPirceBaseUnitHtml += '</span>';
		}

		if (variant.hasOwnProperty('unit_price')) {
			priceHtml += '<span>' + Utils.formatMoney(variant.unit_price) + '</span>';
		}

		priceHtml += unitPriceSeparatorHtml + unitPirceBaseUnitHtml;
		priceHtml += '</dd></div>';

		priceHtml += '<div class="price__badges price__badges--listing">' +
			'<span class="price__badge price__badge--sale" aria-hidden="true"> <span>';
		priceHtml += boostPFSConfig.label.sale + '</span></span>';
		priceHtml += '<span class="price__badge price__badge--sold-out">' +
			boostPFSConfig.label.sold_out +
			'</span></span></div>';

		priceHtml += '</dl>';

		return priceHtml;
	}

	function buildPriceNew(data, onSale, priceVaries) {
		//console.log(data);
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
		var soldOutClass = data.available ? '' : ' price--sold-out';
		var comparePriceVaries = data.compare_at_price_min != data.compare_at_price_max;
		var priceVariesClass = !priceVaries && comparePriceVaries ? ' price--compare-price-hidden' : '',
			variant = data.variants[0],
			unitPriceMeasurementClass = '',
			unitPriceSeparatorHtml = '',
			unitPirceBaseUnitHtml = '';

		if (variant.hasOwnProperty('unit_price_measurement')) {
			unitPriceMeasurementClass = ' price--unit-available';
		}

		priceHtml += '<div class="price price--listing' + onSaleClass + soldOutClass + priceVariesClass + unitPriceMeasurementClass + '" data-price>';
		// if (boostPFSConfig.custom.hasOwnProperty('vendor_enable') && boostPFSConfig.custom.vendor_enable == true) {
		// 	priceHtml += '<div class="price__vendor price__vendor--listing"><dt>';
		// 	priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
		// 	priceHtml += '</dt><dd>';
		// 	priceHtml += data.vendor;
		// 	priceHtml += '</dd></div>';
		// }
		//console.log(data);
		// if(!data.available){
			// if(data.template_suffix == 'gift_cart' || data.template_suffix == 'phisycal_gift_card'){
			// 	priceHtml += '<span class="price-item price-item--regular">From '+Utils.formatMoney(data.price_min)+'</span>';
			// }else{
				//priceHtml += '<span class="price-item price-item--regular">Sold out</span>';
			//}
		//}else{
			if(data.template_suffix == 'gift_cart' || data.template_suffix == 'phisycal_gift_card'){
				priceHtml += '<span class="price-item price-item--regular">From '+Utils.formatMoney(data.price_min)+'</span>';
			}else{
				if(onSale){
					//console.log(data.compare_at_price_min);
					priceHtml += '<span class="price-item price-item--regular">'+Utils.formatMoney(data.compare_at_price_min)+'</span>';
					priceHtml += '<span class="price-item price-item--sale">'+Utils.formatMoney(data.price_min)+'</span>';
				}else{
					priceHtml += '<span class="price-item price-item--regular">'+Utils.formatMoney(data.price_min)+'</span>';
				}
			}
		//}

		// priceHtml += '<div class="price__regular">';
		// priceHtml += '<dt><span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		// priceHtml += '</dt><dd>';
		// priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
		// if (priceVaries) {
		// 	priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
		// } else {
		// 	priceHtml += Utils.formatMoney(data.price_min);
		// }
		// priceHtml += '</span></dd></div>';

		// priceHtml += '<div class="price__sale"> <dt> <span class="visually-hidden visually-hidden--inline">';
		// priceHtml += boostPFSConfig.label.sale_price +
		// 	'</span></dt>';
		// priceHtml += '<dd> <span class="price-item price-item--sale">';
		// if (priceVaries) {
		// 	priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
		// } else {
		// 	priceHtml += Utils.formatMoney(data.price_min);
		// }
		// priceHtml += '</span></dd>';
		// priceHtml += '<div class="price__compare"> <dt> <span class="visually-hidden visually-hidden--inline">';
		// priceHtml += boostPFSConfig.label.regular_price;
		// priceHtml += '</span></dt>';
		// priceHtml += '<dd> <s class="price-item price-item--regular">';
		// priceHtml += Utils.formatMoney(data.compare_at_price_min);
		// priceHtml += '</s></dd></div>';
		// priceHtml += '</div>';

		// priceHtml += '<div class="price__unit"> <dt> <span class="visually-hidden visually-hidden--inline">';
		// priceHtml += boostPFSConfig.label.unit_price_label;
		// priceHtml += '</span></dt>';
		// priceHtml += '<dd class="price-unit-price">';

		// unitPriceSeparatorHtml += '<span aria-hidden="true">/</span><span class="visually-hidden">';
		// unitPriceSeparatorHtml += boostPFSConfig.label.unit_price_separator + '&nbsp;</span>';

		// if (variant.hasOwnProperty('unit_price_measurement') && variant.unit_price_measurement) {
		// 	unitPirceBaseUnitHtml += '<span>';
		// 	if (variant.hasOwnProperty('reference_value') && variant.unit_price_measurement.reference_value != 1) {
		// 		unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_value;
		// 	}
		// 	if (variant.hasOwnProperty('reference_unit')) {
		// 		unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_unit;
		// 	}
		// 	unitPirceBaseUnitHtml += '</span>';
		// }

		// if (variant.hasOwnProperty('unit_price')) {
		// 	priceHtml += '<span>' + Utils.formatMoney(variant.unit_price) + '</span>';
		// }

		// priceHtml += unitPriceSeparatorHtml + unitPirceBaseUnitHtml;
		// priceHtml += '</dd></div>';

		// priceHtml += '<div class="price__badges price__badges--listing">' +
		// 	'<span class="price__badge price__badge--sale" aria-hidden="true"> <span>';
		// priceHtml += boostPFSConfig.label.sale + '</span></span>';
		// priceHtml += '<span class="price__badge price__badge--sold-out">' +
		// 	boostPFSConfig.label.sold_out +
		// 	'</span></span></div>';

		priceHtml += '</div>';

		return priceHtml;
	}

	// Custom Build Variant Colour for Fella Theme (using custom element)
	function buildVariants(data) {
		var tags = (data && data.tags) ? data.tags : [];
		var tagsJson = JSON.stringify(tags);
		var wrapperVariantClass = 'variant_wrapper ProductCardVariantWrapper-' + data.id;

		var variantHtml = '<fh-swatch-group class="' + wrapperVariantClass + '" data-product-handle="' + data.handle + '" data-product-id="' + data.id + '" data-product-tags=\'' + tagsJson + '\'></fh-swatch-group>';

		return variantHtml;
	}

	function updateSingleProductVariantCount(productId) {
		const variantWrapper = document.querySelector(`.ProductCardVariantWrapper-${productId}`);
		if (!variantWrapper) return;

		// Remove existing counts if any
		const existingCount = variantWrapper.querySelector('.variant-count-num');
		const existingCountTotal = variantWrapper.querySelector('.variant-count-total');
		if (existingCount) existingCount.remove();
		if (existingCountTotal) existingCountTotal.remove();

		const variantItems = variantWrapper.querySelectorAll('.variant-item[title-updated="true"]');
		const variantCount = variantItems.length;

		if (variantCount > 0) {
			const countElement = document.createElement('div');
			countElement.classList.add('variant-count-num');
			countElement.textContent = variantCount <= 1 ? `${variantCount} Colour` : `${variantCount} Colours`;
			variantWrapper.appendChild(countElement);

			if (variantCount > 3) {
				const mobileVarShowCount = variantCount - 3;
				const countElementM = document.createElement('div');
				countElementM.classList.add('variant-count-total');
				countElementM.textContent = `+${mobileVarShowCount}`;
				variantWrapper.appendChild(countElementM);
			}
		}

		if (variantCount == 0) {
			variantWrapper.classList.add('hidden');
		}
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;

		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);
		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
		 return '';
		}
		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

	 // Create page items array
		var beforeCurrentPageArr = [];
		for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
			beforeCurrentPageArr.unshift(iBefore);
		}
		if (currentPage - 4 > 0) {
			beforeCurrentPageArr.unshift('...');
		}
		if (currentPage - 4 >= 0) {
			beforeCurrentPageArr.unshift(1);
		}
		beforeCurrentPageArr.push(currentPage);
		var afterCurrentPageArr = [];
		for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
			afterCurrentPageArr.push(iAfter);
		}
		if (currentPage + 3 < totalPage) {
			afterCurrentPageArr.push('...');
		}
		if (currentPage + 3 <= totalPage) {
			afterCurrentPageArr.push(totalPage);
		}

		// Build page items
		var pageItemsHtml = '';
		var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
		for (var iPage = 0; iPage < pageArr.length; iPage++) {
			if (pageArr[iPage] == '...') {
				pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
			} else {
				pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
			}
			pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
			pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
		}
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
		return paginationHtml;
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}

		_removeLabelPrice();
		_showSwatch();
		//_initWishlish();
		/** Start Swym integration **/
		window.SwymCallbacks = window.SwymCallbacks || [];
		window.SwymCallbacks.push(function(swat) {
			// Wrap with callback for loading without additional checks
			var products = [];
			data.forEach(function(product) {
				var image_src = Utils.getFeaturedImage(product.images_info);
				var productCopy = product;
				productCopy.featured_image = image_src;
				productCopy.price = product.price_min; // Sometimes I need to multiply the price with 100
				productCopy.compare_at_price = product.compare_at_price_min; // Sometimes I need to multiply the price with 100
				products.push(productCopy);
			});
			swat.mapShopifyProducts(products); // Product mapped data to swym layer
			swat.initializeActionButtons('.boost-pfs-filter-products'); // Buttons can now be initialized
		});
		/** End Swym integration **/
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		createImageSlider();
		
		appendVariantCount();
		setTimeout(function(){
		VariantClick();
		},2000);
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		// custom for Fella theme
		totalProduct = totalProduct.replace('products', 'items')

		jQ('.boost-pfs-filter-total-product').html(totalProduct);
		jQ('.boost-pfs-search-total-result').html(totalProduct);
	};

	// Add custom banners for special layout Fella Theme
	function _addExtralBanners(itemHtml, customLayoutData, rootData) {
		// declare variables need for process
		var layoutType = customLayoutData.layout_type,
			totalProducts = rootData.totalProduct,
			index = rootData.index;
			currentPage = parseInt(Globals.queryParams.page);

		// Only for first page
		if (currentPage > 1) {
			return itemHtml;
		}

		// For type = layout1
		if (layoutType == 'layout1') {
			// For Banner 1
			if (index == 0) {
				let tmpItemHtml = itemHtml;
				let bannersHtml = _initBannersHtml(customLayoutData.video_1, customLayoutData.banner_1_img, customLayoutData.banner_1_img_mb, customLayoutData.banner_1_link, 1);
				itemHtml = bannersHtml + tmpItemHtml;
			}
			// For Banner 2
			if (index == 5) {
				itemHtml += _initBannersHtml(customLayoutData.video_2, customLayoutData.banner_2_img, customLayoutData.banner_2_img_mb, customLayoutData.banner_2_link, 1, 2);
			}
			// For Banner 3
			if (index == 9) {
				itemHtml += _initBannersHtml(customLayoutData.video_3, customLayoutData.banner_3_img, customLayoutData.banner_3_img_mb, customLayoutData.banner_3_link, 1, 3);
			}
		}

		// For type = layout2
		if (layoutType == 'layout2') {
			// For Banner 1
			if (index == 3) {
				itemHtml += _initBannersHtml(customLayoutData.video_1, customLayoutData.banner_1_img, customLayoutData.banner_1_img_mb, customLayoutData.banner_1_link, 2);
			}
			// For Banner 2
			if (index == 7) {
				itemHtml += _initBannersHtml(customLayoutData.video_2, customLayoutData.banner_2_img, customLayoutData.banner_2_img_mb, customLayoutData.banner_2_link, 2, 2);
			}
			// For Banner 3
			if (index == 11) {
				itemHtml += _initBannersHtml(customLayoutData.video_3, customLayoutData.banner_3_img, customLayoutData.banner_3_img_mb, customLayoutData.banner_3_link, 2, 3);
			}
		}

		// For type = layout3
		if (layoutType == 'layout3') {
			// For Banner 1
			if (index == 3) {
				itemHtml += _initBannersHtml(customLayoutData.video_1, customLayoutData.banner_1_img, customLayoutData.banner_1_img_mb, customLayoutData.banner_1_link, 3);
			}
			// For Banner 2
			if (index == 7) {
				itemHtml += _initBannersHtml(customLayoutData.video_2, customLayoutData.banner_2_img, customLayoutData.banner_2_img_mb, customLayoutData.banner_2_link, 3, 2);
			}
			// For Banner 3
			if (index == 11) {
				itemHtml += _initBannersHtml(customLayoutData.video_3, customLayoutData.banner_3_img, customLayoutData.banner_3_img_mb, customLayoutData.banner_3_link, 3, 3);
			}
		}

		// For type = layout4
		if (layoutType == 'layout4') {
			// For Banner 1
			if (index == 5) {
				itemHtml += _initBannersHtml(customLayoutData.video_1, customLayoutData.banner_1_img, customLayoutData.banner_1_img_mb, customLayoutData.banner_1_link, 4);
			}
			// For Banner 2
			if (index == 11) {
				itemHtml += _initBannersHtml(customLayoutData.video_2, customLayoutData.banner_2_img, customLayoutData.banner_2_img_mb, customLayoutData.banner_2_link, 4, 2);
			}
			// For Banner 3
			if (index == 17) {
				itemHtml += _initBannersHtml(customLayoutData.video_3, customLayoutData.banner_3_img, customLayoutData.banner_3_img_mb, customLayoutData.banner_3_link, 4, 3);
			}
		}

		return itemHtml;
	};

	// Init Html for banners
	function _initBannersHtml(video, bannersImg, bannersImgMb, bannersLink, type, position = 1) {
		let positionClassName = 'banner_position_';
		switch (position) {
			case 1 :
				positionClassName += 'one';
				break;
			case 2 :
				positionClassName += 'two';
				break;
			case 3 :
				positionClassName += 'three';
				break;
		}

		let bannersHtml = '<div class="layout'+type+'-banner banner_item '+positionClassName+'">';
		let link = bannersLink ? bannersLink : '#';
        if (bannersImgMb){
            bannersHtml += '<div class="img-wrapper">';
        }else{
            bannersHtml += '<div class="img-wrapper no-mobile">';
        }
		bannersHtml += '<a href="'+ link +'" >';
		if (video) {
			bannersHtml += '<video autoplay="autoplay" muted loop="loop" playsinline="playsinline" preload="metadata" src="' + video[0].src + '" type="video/mp4">';
			bannersHtml += '<source src="' + video[0].src + '" type="application/x-mpegURL">';
			bannersHtml += '<source src="' + video[0].src + '" type="video/mp4">';
			bannersHtml += '</video>';
		} else {
			if (bannersImg) {
				let imgData = {
					alt : bannersImg[0][0].alt != '' ? bannersImg.alt : 'Banners ' + position,
					src : bannersImg[0][0].src
				};
				bannersHtml += '<img alt="'+imgData.alt+'" src="'+imgData.src+'" class="hidden-small">';
			}
			if (bannersImgMb) {
				let imgMbData = {
					alt : bannersImgMb[0][0].alt != '' ? bannersImgMb.alt : 'Banners mobile ' + position,
					src : bannersImgMb[0][0].src
				};
				bannersHtml += '<img alt="'+imgMbData.alt+'" src="'+imgMbData.src+'" class="hidden-larger">';
			}
		}
		bannersHtml += '</div></a></div>';

		return bannersHtml;
	};

	// Add to wishlist
	function _initWishlish() {
		// Add wishlist
		if (window._swat) {
			window._swat.initializeActionButtons(".boost-pfs-filter-products");
		} else {
			window.SwymCallbacks = window.SwymCallbacks || [];
			window.SwymCallbacks.push(function () {
				window._swat.initializeActionButtons(".boost-pfs-filter-products");
			});
		}
	};

	// Remove label "from" on from_lowest_price
	function _removeLabelPrice() {
		let priceSpan = $('span.price-item');
		if (priceSpan.length > 0) {
			$.each(priceSpan, function(index, elm){
				let text = $(elm).text();
				$(elm).text(text.replace("from ", ""));
			});
		}
	};

	function _showSwatch() {
		let swatch = $('.variant_wrapper');
		swatch.addClass('active');
		// if (priceSpan.length > 0) {
		// 	$.each(priceSpan, function(index, elm){
		// 		let text = $(elm).text();
		// 		$(elm).text(text.replace("from ", ""));
		// 	});
		// }
		jQuery('.variant_wrapper > .variant-item').on('click', function(e) {
            e.preventDefault();
            if (jQuery(this).hasClass('active')){
                return true;
            } else {
                // if (jQuery(this).data('action') == 0){
                //     return true;
                // }
                let itemId = jQuery(this).data('id');
                //console.log(itemId);
                let data_hanlde = jQuery(this).data('product-handle');
                let data_img_url = '';
                let data_price = '';
                let data_product_title = '';
                let data_product_url = '';
                let is_new = false;
                let is_preorder = false;
                jQuery(this).siblings('.variant-item').removeClass('active');
                jQuery(this).addClass('active');
                jQuery.getJSON('/products/'+data_hanlde+'.js', function(product) {

                 data_img_url += '<div class="v_img_slider">';
                  if(product.images){
                    const startingIndexV = 1; // The index of 'image2.jpg'
                    for (let i = startingIndexV; i < product.images.length; i++) {
                    data_img_url += '<a href="'+ product.url+'" class="variant_images featured_image"><img class="grid-view-item__image" src="' + product.images[i] + '" > </a>';
                    }

                  }
                  else{
                        if(product.featured_image != null){
                            data_img_url = '<a href="'+ product.url+'" class="variant_images featured_image"><img class="grid-view-item__image" src="'+product.featured_image+'" ><img class="grid-view-item__image" src="'+product.featured_image+'" ></a>';
                        }
                    }
                    data_img_url += '</div>';
                    data_product_title = product.title;
                    data_product_url = product.url;
                    let is_sale = product.compare_at_price_min > product.price_min;
                    //console.log(product);
                    if(product.tags.indexOf("NEWARRIVALS") > -1 || product.tags.indexOf("NEWARRIVAL") > -1){
                        is_new = true;
                    }
                    if(product.tags.indexOf("W-PREORDER") > -1){
                        is_preorder = true;
                    }
                    if(!product.available){
                        data_price += '<div class="price price--listing price--sold-out">';
                        data_price += '<span class="price-item price-item--regular">Sold out</span>';
                        data_price += '</div>';
                    }else{
                        if(product.compare_at_price_min > product.price_min){
                            data_price += '<div class="price price--listing price--on-sale">';
                            data_price += '<span class="price-item price-item--regular">'+Shopify.formatMoney(product.compare_at_price_min)+'</span>';
                            data_price += '<span class="price-item price-item--sale">'+Shopify.formatMoney(product.price)+'</span>';
                            data_price += '</div>';
                        }else{
                            data_price += '<div class="price price--listing">';
                            data_price += '<span class="price-item price-item--regular">'+Shopify.formatMoney(product.price)+'</span>';
                            data_price += '</div>';
                        }
                    }
                    var v_hover_image = product.featured_image;
                    jQuery('.grid').find('#ProductCardImageWrapper-'+itemId+' .show_img_on_hover').attr("src", v_hover_image);
                    //update product image
                    if(data_img_url != ''){
                        jQuery('.grid').find('#ProductCardImageWrapper-'+itemId+' .p_img_slider').remove();
                        jQuery('.grid').find('#ProductCardImageWrapper-'+itemId+' .v_img_slider').remove();
                        jQuery('.grid').find('#ProductCardImageWrapper-'+itemId+' ').prepend(data_img_url);
                      setTimeout(function(){
                      $('#ProductCardImageWrapper-'+itemId+' .v_img_slider').slick({
                                dots: false,
                                infinite: true,
                                draggable: true,
                                touchMove: true,
                                speed: 300,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: true,
                                prevArrow: '<button class="prevButton prev-btn"><svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-carousel-arrow="arrow_left" class="swiper-prev q0_CzkvsgDMf4wuhU-Mmd swiper-prev-product-tile-0b2b6890-9c58-4599-b5bc-7a16e3fe7bc1"><path d="M17.863 20.747a.587.587 0 01-.012.767.453.453 0 01-.689-.013l-5.025-5.793a.588.588 0 010-.755l5.025-5.787a.453.453 0 01.69-.013.587.587 0 01.011.767l-4.698 5.411 4.698 5.416z" fill="#414B56"></path></svg></button>',
                                nextArrow: '<button class="nextButton next-btn"><svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-carousel-arrow="arrow_right" class="swiper-next _3_YpTjuvY8Z870NbXHqbRr swiper-next-product-tile-0b2b6890-9c58-4599-b5bc-7a16e3fe7bc1"><path d="M13.137 20.747a.587.587 0 00.012.767.453.453 0 00.689-.013l5.025-5.793a.588.588 0 000-.755l-5.025-5.787a.453.453 0 00-.69-.013.587.587 0 00-.011.767l4.698 5.411-4.698 5.416z" fill="#414B56"></path></svg></button>'
                                });
                        }, 100);
                          jQuery('#ProductCardImageWrapper-'+itemId+' .p_img_slider').hide('');
                          jQuery('#ProductCardImageWrapper-'+itemId+' .p_img_slider').slick('unslick');

                    }

                    //update price
                    jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.product-price').html(data_price);

                    // update label
                    jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.product-label>span').removeClass('show').addClass('hide');
                    if (is_sale) {
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.label-sale').addClass('show').removeClass('hide');
                        is_preorder = false;
                        is_new = false;
                    } else if (is_preorder) {
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.label-preorder').addClass('show').removeClass('hide');
                        is_new = false;
                    } else if (is_new) {
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.label-new').addClass('show').removeClass('hide');
                    }

                    // update title
                    if(data_product_title){
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('.product-card__title h4').text(data_product_title);
                    }

                    // update url
                    if(data_product_url){
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('a.featured_image').attr('href', data_product_url);
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('a.product-card__title').attr('href', data_product_url);
                    }
                });

            }
        });
	};



// End new custom js


})();


function createImageSlider() {
      $('.p_img_slider').slick({
        dots: false,
        infinite: true,
        draggable: true,
        touchMove: true,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        prevArrow: '<button class="prevButton prev-btn"><svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-carousel-arrow="arrow_left" class="swiper-prev q0_CzkvsgDMf4wuhU-Mmd swiper-prev-product-tile-0b2b6890-9c58-4599-b5bc-7a16e3fe7bc1"><path d="M17.863 20.747a.587.587 0 01-.012.767.453.453 0 01-.689-.013l-5.025-5.793a.588.588 0 010-.755l5.025-5.787a.453.453 0 01.69-.013.587.587 0 01.011.767l-4.698 5.411 4.698 5.416z" fill="#414B56"></path></svg></button>',
        nextArrow: '<button class="nextButton next-btn"><svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-carousel-arrow="arrow_right" class="swiper-next _3_YpTjuvY8Z870NbXHqbRr swiper-next-product-tile-0b2b6890-9c58-4599-b5bc-7a16e3fe7bc1"><path d="M13.137 20.747a.587.587 0 00.012.767.453.453 0 00.689-.013l5.025-5.793a.588.588 0 000-.755l-5.025-5.787a.453.453 0 00-.69-.013.587.587 0 00-.011.767l4.698 5.411-4.698 5.416z" fill="#414B56"></path></svg></button>'
      });
}
function appendVariantCount() {
    const variantWrappers = document.querySelectorAll('.variant_wrapper');
    variantWrappers.forEach(variantWrapper => { 
        // if already rendered for this wrapper, skip to avoid duplicates
        if (variantWrapper.querySelector('.variant-count-num')) return;

        const variantItems = variantWrapper.querySelectorAll('.variant-item[title-updated="true"]');
        const variantCount = variantItems.length;

        if (variantCount === 0) {
            variantWrapper.classList.add('hidden');
            return;
        }
        variantWrapper.classList.remove('hidden');

        setTimeout(function(){
          const countElement = document.createElement('div');
          countElement.classList.add('variant-count-num');
          countElement.textContent = (variantCount <= 1) ? `${variantCount} Colour` : `${variantCount} Colours`;
          variantWrapper.appendChild(countElement);
        },100);

        if (variantCount > 3) {
            const mobileVarShowCount = variantCount - 3;
            const countElementM = document.createElement('div');
            countElementM.classList.add('variant-count-total');
            countElementM.textContent = `+${mobileVarShowCount}`;
            variantWrapper.appendChild(countElementM);
        }
    });
}
//FilterResult.prototype.afterRender = function() {}
// ProductList.prototype.afterRender = function() {  }
function VariantClick() {
jQuery('.variant_wrapper > .variant-item').on('click', function(e) {
            e.preventDefault();
            if (jQuery(this).hasClass('active')){
                return true;
            } else { 
                let itemId = jQuery(this).data('id');
                //console.log(itemId);
                let data_hanlde = jQuery(this).data('product-handle');
                let data_img_url = ''; 
                let data_product_url = ''; 
                jQuery(this).siblings('.variant-item').removeClass('active');
                jQuery(this).addClass('active');
                jQuery.getJSON('/products/'+data_hanlde+'.js', function(product) {
 data_img_url += '<div class="v_img_slider">';
                  if(product.images){
                    const startingIndexV = 1; // The index of 'image2.jpg'
                    for (let i = startingIndexV; i < product.images.length; i++) {
                    data_img_url += '<a href="'+ product.url+'" class="variant_images featured_image"><img class="grid-view-item__image" src="' + product.images[i] + '" > </a>';
                    }

                  }
                  else{
                        if(product.featured_image != null){
                            data_img_url = '<a href="'+ product.url+'" class="variant_images featured_image"><img class="grid-view-item__image" src="'+product.featured_image+'" ><img class="grid-view-item__image" src="'+product.featured_image+'" ></a>';
                        }
                    }
                    data_img_url += '</div>';
                    data_product_url = product.url;
                     
                      
                    var v_hover_image = product.featured_image;
                    jQuery('.grid').find('#ProductCardImageWrapper-'+itemId+' .show_img_on_hover').attr("src", v_hover_image);
                    if(data_img_url != ''){
                        jQuery('.grid').find('#ProductCardImageWrapper-'+itemId+' .p_img_slider').remove();
                        jQuery('.grid').find('#ProductCardImageWrapper-'+itemId+' .v_img_slider').remove();
                        jQuery('.grid').find('#ProductCardImageWrapper-'+itemId+' ').prepend(data_img_url);
                      setTimeout(function(){
                      $('#ProductCardImageWrapper-'+itemId+' .v_img_slider').slick({
                                dots: false,
                                infinite: true,
                                draggable: true,
                                touchMove: true,
                                speed: 300,
                                slidesToShow: 1,
                                slidesToScroll: 1,
                                arrows: true,
                                prevArrow: '<button class="prevButton prev-btn"><svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-carousel-arrow="arrow_left" class="swiper-prev q0_CzkvsgDMf4wuhU-Mmd swiper-prev-product-tile-0b2b6890-9c58-4599-b5bc-7a16e3fe7bc1"><path d="M17.863 20.747a.587.587 0 01-.012.767.453.453 0 01-.689-.013l-5.025-5.793a.588.588 0 010-.755l5.025-5.787a.453.453 0 01.69-.013.587.587 0 01.011.767l-4.698 5.411 4.698 5.416z" fill="#414B56"></path></svg></button>',
                                nextArrow: '<button class="nextButton next-btn"><svg width="1em" height="1em" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg" data-carousel-arrow="arrow_right" class="swiper-next _3_YpTjuvY8Z870NbXHqbRr swiper-next-product-tile-0b2b6890-9c58-4599-b5bc-7a16e3fe7bc1"><path d="M13.137 20.747a.587.587 0 00.012.767.453.453 0 00.689-.013l5.025-5.793a.588.588 0 000-.755l-5.025-5.787a.453.453 0 00-.69-.013.587.587 0 00-.011.767l4.698 5.411-4.698 5.416z" fill="#414B56"></path></svg></button>'
                                });
                        }, 100);
                          jQuery('#ProductCardImageWrapper-'+itemId+' .p_img_slider').hide('');
                          jQuery('#ProductCardImageWrapper-'+itemId+' .p_img_slider').slick('unslick');

                    }

                    // update url
                    if(data_product_url){ 
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('a.featured_image').attr('href', data_product_url);
                        jQuery('.grid').find('.grid__item[data-id="'+itemId+'"]').find('a.product-card__title').attr('href', data_product_url);
                    }
                });

            }
        });
	}